<!-- Layout wrapper -->
<div class="layout-wrapper layout-content-navbar">
  <div class="layout-container">
    <!-- Sidebar -->
    <app-sidebar></app-sidebar>
    <!-- Layout container -->
    <div class="layout-page">
      <!-- Header -->
      <app-header></app-header>
        <!-- Content wrapper -->
        <div class="content-wrapper">
          <!-- content Body -->
          <div class="container-xxl flex-grow-1 container-p-y">
            <router-outlet></router-outlet>
          </div>
          <!-- <app-content-body></app-content-body> -->
          <!-- Footer -->
          <app-footer></app-footer>

          <div class="content-backdrop fade"></div>
        </div>
      <!-- Content wrapper -->
    </div>
    <!-- / Layout page -->
  </div>
  <!-- Overlay -->
  <div class="layout-overlay layout-menu-toggle"></div>
  <!-- Drag Target Area To SlideIn Menu On Small Screens -->
  <div class="drag-target"></div>
</div>
<!-- / Layout wrapper -->
